var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      "item-text": "name",
      "item-value": "uid",
      label: _vm.label,
      clearable: _vm.clearable,
      disabled: _vm.disabled,
      "hide-details": "",
    },
    model: {
      value: _vm.value,
      callback: function ($$v) {
        _vm.value = $$v
      },
      expression: "value",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }